import FILTER_TYPES from '@/components/query/filter-types';
import FILTER_SOURCE_TYPES from '@/components/query/filter-source-type';
import _ from '@/common/helpers';

export default {
    id: 'users',
    version: 1,
    filterSpec: {
        id: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'users',
                labelBuilder: ({id, email}) => `${_.truncate(id, {limit: 11, dots: true})} - ${email}`,
                value: 'id',
            },
        },
        email: {
            type: FILTER_TYPES.select,
            options: {
                source: FILTER_SOURCE_TYPES.rebillyAPI,
                path: 'users',
                labelBuilder: ({email}) => email,
                value: 'email',
            },
        },
        firstName: {
            type: FILTER_TYPES.text,
        },
        lastName: {
            type: FILTER_TYPES.text,
        },
        createdTime: {
            type: FILTER_TYPES.datetime,
        },
        updatedTime: {
            type: FILTER_TYPES.datetime,
        },
        // TODO: these filters are not functional
        // status: {
        //     type: FILTER_TYPES.select,
        //     options: {
        //         source: FILTER_SOURCE_TYPES.definitions,
        //         path: 'User/status/enum',
        //     },
        // },
        // businessPhone: {
        //     type: FILTER_TYPES.text,
        // },
        // mobilePhone: {
        //     type: FILTER_TYPES.text,
        // },
        // permissions: {
        // }
    },
};
